"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.date = void 0;
const dateFns = __importStar(require("date-fns"));
const create_fn_1 = require("../utils/create-fn");
const dates_1 = require("../utils/dates");
const get_arg_1 = require("../utils/get-arg");
// Emulates the CFML function [DateAdd()](https://helpx.adobe.com/coldfusion/cfml-reference/coldfusion-functions/functions-c-d/DateAdd.html)
// by allowing years, months, days and hours to be added to a date
const add = (0, create_fn_1.createFn)("fn.date.add", (args, context) => {
    const datePart = (0, get_arg_1.getArgString)(args, 1, context);
    const value = (0, get_arg_1.getArgNumber)(args, 2, context);
    const dateArg = (0, get_arg_1.getArgDateOrUndefined)(args, 3, context);
    if (dateArg === undefined) {
        return undefined;
    }
    switch (datePart) {
        case "yyyy":
            return dateFns.add(dateArg, {
                years: value,
            });
        case "m":
            return dateFns.add(dateArg, {
                months: value,
            });
        case "d":
            return dateFns.add(dateArg, {
                days: value,
            });
        case "h":
            return dateFns.add(dateArg, {
                hours: value,
            });
        default:
            throw new Error(`The 1st arg of "${datePart}" is not supported`);
    }
});
// Formats a `Date` object to a string using the pattern provided
const format = (0, create_fn_1.createFn)("fn.date.format", (args, context) => {
    const dateArg = (0, get_arg_1.getArgDateOrUndefined)(args, 1, context);
    if (dateArg === undefined) {
        return "";
    }
    const pattern = (0, get_arg_1.getArgStringStrict)(args, 2, context);
    return dateFns.format(dateArg, pattern);
});
// Returns the year of a `Date` object
const getyear = (0, create_fn_1.createFn)("fn.date.getyear", (args, context) => {
    const dateArg = (0, get_arg_1.getArgDateOrUndefined)(args, 1, context);
    if (dateArg === undefined) {
        return undefined;
    }
    return dateFns.getYear(dateArg);
});
const isdate = (0, create_fn_1.createFn)("fn.date.isdate", (args, context) => {
    const arg = (0, get_arg_1.getArgUnknown)(args, 1, context);
    if (typeof arg === "string") {
        return dates_1.reMMDDYYYY.test(arg) || dates_1.reYYYYMMDD.test(arg);
    }
    return arg instanceof Date;
});
// Returns the current date and time
const now = (0, create_fn_1.createFn)("fn.date.now", () => {
    return new Date();
});
// Parses a ISO date string into a `Date` object
const parseiso = (0, create_fn_1.createFn)("fn.date.parseiso", (args, context) => {
    const dateArg = (0, get_arg_1.getArgStringStrict)(args, 1, context);
    return dateFns.parseISO(dateArg);
});
// Returns the difference is hours, months, days or years between two dates.
// The type of differencing used is determined by the datePart argument.
// Options are h, m, d and y.
const diff = (0, create_fn_1.createFn)("fn.date.diff", (args, context) => {
    const datePartValue = (0, get_arg_1.getArgString)(args, 1, context);
    const dateValue1 = (0, get_arg_1.getArgDateOrUndefined)(args, 2, context);
    const dateValue2 = (0, get_arg_1.getArgDateOrUndefined)(args, 3, context);
    if (dateValue1 === undefined || dateValue2 === undefined) {
        return undefined;
    }
    switch (datePartValue) {
        case "h":
            return dateFns.differenceInHours(dateValue1, dateValue2);
        case "m":
            return dateFns.differenceInMonths(dateValue1, dateValue2);
        case "d":
            return dateFns.differenceInDays(dateValue1, dateValue2);
        case "y":
            return dateFns.differenceInYears(dateValue1, dateValue2);
        default:
            throw new Error(`The 1st arg of "${datePartValue}" is not supported`);
    }
});
exports.date = {
    add,
    format,
    getyear,
    isdate,
    now,
    parseiso,
    diff,
};
//# sourceMappingURL=date.js.map